<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path fill="currentColor" d="M5.60168 10.017C5.60479 10.3609 5.74154 10.6914 5.98291 10.9369L12.3477 17.3017C12.8657 17.8207 13.7058 17.8228 14.2248 17.3058C14.4745 17.0572 14.6154 16.7195 14.6164 16.3683C14.6164 16.0161 14.4776 15.6783 14.229 15.4287L8.80061 10.0003L14.229 4.57191C14.747 4.05188 14.7449 3.21173 14.2249 2.6948C13.7059 2.17684 12.8657 2.1789 12.3477 2.69894L5.98293 9.06375C5.73327 9.31756 5.59653 9.66045 5.6017 10.0168L5.60168 10.017Z" />
  </svg>
</template>
